import React from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { PLATFORM_MENU } from "../../../constants/platformMenu";
import { usePlatform } from "../../../contexts/PlatformContext";
import neoLogo from "../../../assets/images/Neo_Logo_White.svg";

/**
 * PlatformSidebar — Menu lateral do Painel Administrativo Global.
 *
 * Visual: sidebar alinhada com os padrões de cores e estilos do NeoApp.
 * Inclui link "Voltar ao App" para retornar à experiência normal.
 */
const PlatformSidebar = () => {
    const location = useLocation();
    const { canPlatform } = usePlatform();

    const isActive = (path) => {
        if (path === "/platform") {
            return location.pathname === "/platform";
        }
        return location.pathname.startsWith(path);
    };

    const visibleItems = PLATFORM_MENU.filter((item) => canPlatform(item.permission));

    return (
        <div className="platform-sidebar-container">
            {/* Logo / Branding */}
            <div className="platform-sidebar-brand">
                <Link to="/platform">
                    <img src={neoLogo} alt="NeoApp" className="platform-sidebar-logo" />
                </Link>
            </div>

            <SimpleBar style={{ height: "calc(100% - 140px)" }}>
                <ul className="platform-sidebar-menu">
                    {visibleItems.map((item, index) => (
                        <li key={index} className="platform-sidebar-item">
                            <Link
                                to={item.path}
                                className={`platform-sidebar-link ${isActive(item.path) ? "active" : ""}`}
                            >
                                <i className={`${item.icon} platform-item-icon`} />
                                <span className="platform-item-label">{item.label}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </SimpleBar>

            {/* Footer: Voltar ao App */}
            <div className="platform-sidebar-footer">
                <Link to="/home" className="platform-back-link">
                    <i className="ph-light ph-arrow-left" />
                    <span>Voltar ao App</span>
                </Link>
            </div>
        </div>
    );
};

export default PlatformSidebar;
